import MovieCard from "./MovieCard";
import Paginate from "./Paginate";
const MovieList=()=>{
    return(
        <div>
            <MovieCard/>
            <Paginate/>
        </div>
    );
};
export default MovieList;